var _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSou1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 400,
    viewBox: "0 0 300 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.4669 0 0 .49874 -17.75 -28.276)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "matrix(.97502 -.21583 .22384 .97607 -18.206 79.986)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m293.04 673.851-6.48 58.539c-18.403-.942-31.308-7.63-43.641-11.54 7.7 14.943 21.57 24.32 38.774 33.55l-6.423 41.36c-27.112-4.673-31.472-5.42-52.556-8.461 18.844 7.43 25.513 11.406 38.505 17.71-22.8 3.804-29.598 5.084-60.794 12.183 32.163-1.206 43.32.489 68.437-.405-10.851 7.992-21.694 10.385-31.457 24.617 25.977-5.272 46.719-16.754 60.162-23.198 12.408-1.699 21.107-4.151 38.942-7.147-7.73-4.878-21.381-8.31-35.605-11.696l5.444-43.435c25.697-4.213 43.571-16.89 56.43-21.38-19.789 3.63-31.82 1.85-52.444-.302l6.775-59.52z",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.676 526.53c-27.325-13.07-34.654-22.28-43.304-31.744-17.86-19.097-35.065-29.803-55.835-43.121 17.839 15.233 33.406 27.664 48.753 54.205l-49.475-9.25c36.118 12.494 63.512 28.865 81.975 46.794z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.918 586.553c41.6-19.489 77.213-43.33 130.068-56.41-59.05 22.31-91.228 43.256-120.172 73.559-3.119 6.387.496 12.775 1.654 19.163l-29.021-49.975c6.856 7.183 12.156 15.929 17.471 13.663z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".91780353px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.25 523.929c12.092 17.886 78.177-38.98 112.692-61.322l-64.01 52.288 62.353-36.46c-36.538 28.588-79.532 47.528-93.761 77.9z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".64343536px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.7 192.268c-5.679.864-9.181-.211-11.538-2.04-3.218-2.178-5.547-4.747-7.632-7.387-5.237-6.597-9.596-13.516-15.626-19.888a69 69 0 0 0-3.704-3.746c-3.267 7.732-5.987 15.869-6.4 23.713-.402 7.705 1.72 15.097 6.67 19.797.146-.179.908-.57 1.87-1.152 1.546-.849 4.204-1.362 7.66-2.046 3.036-.528 6.944-.876 11.655-1.537 1.865-.232 4.269-.646 7.176-1.37 2.082-.292 5.432-1.664 9.87-4.344m-38.23 10.45a21.7 21.7 0 0 0-3.904-2.584c-14.357-.679-27.99-3.062-41.826-5.221 4.029 8.911 7.92 17.993 12.153 26.785 2.522 5.187 5.247 10.204 8.524 14.563 1.04-1.6 2.326-3.357 3.764-5.318 6.419-8.524 14.007-17.543 21.3-28.132q-.066-.028-.01-.094m-25.053 33.543c-3.094-.596-6.203-1.077-9.36-1.32-7.326-.649-15.216.086-22.776 4.024-4.426 2.343-8.633 5.65-12.425 9.61a47.8 47.8 0 0 0 11.55 6.23c11.556 4.205 23.053 4.109 34.139 3.35-1.949-3.967-3.506-7.343-4.04-10.177-.364-1.947-.564-3.564-.306-4.576.049-.998.705-2.491 1.608-4.38.43-.868.975-1.785 1.61-2.761m1.128 21.894-.002.002c-9.64 14.405-16.653 26.379-21.998 34.708 15.428.855 29.683 4.323 43.176 11.684-8.46-15.656-16.128-30.8-21.176-46.394zm21.176 46.394c-1.969 3.246-3.75 5.893-5.4 7.869-9.442 1.938-19.122 2.491-28.959 1.757 3.476 6.555 8.107 17.364 13.728 31.973a230.4 230.4 0 0 1 25.852-32.02c-1.763-3.219-3.508-6.41-5.22-9.579m-20.631 41.599a109 109 0 0 1-16.36-1.349c-9.897-2.086-20.256-3.272-31.052-2.872 2.287 4.914 4.829 9.62 7.65 14.045 5.696 8.955 12.639 16.846 20.73 22.167.81-2.912 2.157-6.023 3.786-9.27 2.564-4.957 6.056-9.807 10.072-14.612a224 224 0 0 1 5.174-8.109m-19.031 31.991c-3.765.275-7.536.894-11.272 1.947-10.75 2.928-21.374 9.895-28.761 21.386q2.521 1.1 5.064 1.938c14.962 4.723 29.151 1.956 40.75-3.887-2.812-2.904-5-5.801-5.759-8.513-1.02-2.543-1.172-5.928-.734-9.366a23.4 23.4 0 0 1 .712-3.505m5.78 21.384a53 53 0 0 0-1.989 4.645c-4.505 12.575-4.973 27.128-3.311 41.835 6.162-3.606 11.856-7.68 17.202-11.975 6.862-5.506 13.155-11.41 19.003-17.603a128 128 0 0 1-9.88-3.794c-7.933-3.546-14.96-7.227-19.85-11.927a62 62 0 0 1-1.175-1.18m30.905 16.902c2.082 15.256 6.29 30.739 11.607 46.076a329 329 0 0 0 10.561-12.46 915 915 0 0 0 18.586-24.33 855 855 0 0 1-13.642-2.226c-9.442-1.937-18.558-4.157-27.112-7.06m40.754 9.287c5.204 14.762 10.853 29.488 17.032 44.15 9.232-12.75 18.022-25.668 26.29-38.76-14.437-1.318-28.883-3.155-43.322-5.39m43.323 5.39a652 652 0 0 0 14.997 32.558q2.574 5.204 5.247 10.384c8.232-13.381 15.937-26.927 23.201-40.6a578 578 0 0 1-26.49-1.041 581 581 0 0 1-16.955-1.301m43.445 2.342c7.3 13.92 15.11 27.717 23.322 41.384a958 958 0 0 0 12.48-24.895c2.754-5.69 5.457-11.392 8.124-17.102q-4.34.175-8.661.313c-11.793.374-23.554.5-35.265.3m43.926-.613c8.195 13.475 16.699 26.86 25.275 40.211 6.553-14.17 12.964-28.364 19.44-42.55-15.049.857-29.95 1.744-44.715 2.339m44.715-2.34c3.61 5.613 7.221 11.228 10.816 16.848 4.936 7.726 9.887 15.463 14.843 23.213 6.483-14.135 12.938-28.235 19.42-42.29-11.768.458-23.508 1.03-35.22 1.676q-4.94.271-9.859.553m45.079-2.23c8.564 13.47 17.123 26.987 25.616 40.562a4054 4054 0 0 1 16.059-34.157 335 335 0 0 0 3.276-7.836q-1.819.184-3.648.354c-13.804.162-27.573.542-41.303 1.077m44.95-1.43c8.048 13.03 17.105 25.8 27.857 37.806 5.633-15.04 9.763-30.192 11.68-45.259-12.328 3.898-25.67 6.042-39.536 7.452m39.538-7.453q.808.869 1.633 1.728c10.14 10.424 21.684 20.31 35.845 27.46.763-9.682.455-19.16-1.323-28.093-1.25-6.19-3.273-12.08-6.07-17.318-1.3 1.33-2.753 2.635-4.3 3.903-6.391 5.176-15.127 8.788-24.796 12.003q-.493.16-.99.317m30.085-16.223c9.573 4.326 20.63 6.358 32.414 4.116 4.682-.918 9.401-2.497 14.034-4.677-7.75-10.006-17.778-16.653-28.112-20.082a65 65 0 0 0-11.737-2.774 29 29 0 0 1 .488 3.717c.3 4.369-.215 8.696-1.784 12.033-.976 2.6-2.872 5.18-5.303 7.667m6.599-23.417c9.339-5.623 17.453-14.394 23.98-24.586a116 116 0 0 0 6.264-11.07c-13.922-.962-27.276.647-39.754 3.9a128 128 0 0 0-6.507 1.884 95 95 0 0 1 1.719 2.036c4.212 5.194 7.805 10.63 10.392 16.254 1.783 3.983 3.185 7.885 3.906 11.582m-16.017-29.872c5.595-12.401 9.333-26.163 10.65-40.848q.442-1.887.878-3.453c-12.412 8.63-26.19 11.08-39.042 7.942a72 72 0 0 1-2.019-2.3 432 432 0 0 1-.95 3.17c6.013 6.957 12.071 15.076 18.223 23.774 4.416 3.467 8.522 7.41 12.26 11.715m-29.533-38.658c11.536-11.352 25.684-16.46 42.49-16.835-2.107-2.377-4.515-5.221-7.237-8.503-6.787-8.84-14.434-16.81-22.932-22.829-.935 3.677-2.302 7.49-3.916 11.408-1.804 12.32-4.794 24.532-8.405 36.759m12.32-48.167c5.715-.876 11.415-2.288 17.027-4.427 8.926-3.384 17.655-8.704 25.128-16.513-3.392-1.87-6.851-3.45-10.342-4.704-12.04-4.313-24.315-4.431-35.03-1.282 1.808 2.75 3.168 5.77 3.868 8.781.906 3.447.968 7.527.514 11.818-.215 2.057-.615 4.169-1.164 6.327m-3.217-26.926.026-.033c9.07-11.646 12.77-27.813 13.2-44.676-6.558 2.491-12.69 5.59-18.439 9.003-7.632 4.876-15.482 8.182-23.94 9.583 4.11 3.524 8.03 7.094 11.713 10.788 7.554 4.818 14.062 9.698 17.433 15.324zm-29.153-26.123c-.075-11.095.223-18.698 2.051-22.384a95 95 0 0 1 10.678-7.21c-5.859-2.434-14.394-8.62-25.834-17.098-.813 10.59-2.562 21.363-4.703 32.31 6.214 4.837 12.189 9.566 17.808 14.382M500.453 163.3c8.25-5.545 17.28-9.956 26.995-13.686 5.21-2.296 10.392-5.047 15.357-8.429-13.216-9.355-27.92-15.597-42.035-14.566q-.661.052-1.318.126l.122.315c2.105 4.723 1.957 11.576 1.29 19.277.192 5.6.026 11.255-.411 16.963m-1-36.555a41.9 41.9 0 0 0 13.136-16.576c3.053-6.935 4.397-15.143 3.79-23.752a67 67 0 0 0-.202-2.231c-16.824 5.359-28.075 16.977-35.692 29.438 5.236 1.146 9.805 2.616 12.722 4.97 1.46 1.065 2.75 2.281 3.721 3.576.994 1.258 1.839 2.838 2.524 4.575m-18.968-13.121a67 67 0 0 0-.326-1.62c-3.132-14.126-10.708-27.912-20.403-40.58a143 143 0 0 0-4.07 8.342c-5.292 11.743-8.971 23.738-11.365 35.743 4.918-1.148 9.839-1.996 14.73-2.48 7.445-.683 14.514-.747 20.84.467q.299.063.594.128m-36.164 1.885c-4.654-5.745-9.796-11.255-15.332-16.503a190 190 0 0 0-19.212-15.958c-1.983 12.163-2.82 24.234-2.437 36.003a55 55 0 0 1-2.201 10.31q3.31-.917 6.688-1.798c7.293-3.852 15.045-7.007 23.064-9.498a142 142 0 0 1 9.43-2.556M405.14 129.36c-13.73-8.137-21.38-14.301-23.544-16.944q-.251-2.163-.41-4.344c-3.744 3.32-12.316 7.22-23.413 13.181 7.054 4.857 14.035 10.6 21.187 16.652 8.12-3.186 16.934-5.981 26.18-8.545m-47.367-8.107c-2.217-15.128-1.86-30.833-2.008-47.775l-.527.331c-11.204 5.593-20.827 13.653-25.76 23.438a37.3 37.3 0 0 0-3.35 9.983c.75-.03 1.493-.002 2.208.085 2.285.151 5.042 1.213 8.052 2.68 7.355 2.513 14.405 6.452 21.385 11.258m-31.645-14.023c-1.45-5.193-4.219-10.18-8.14-14.5-6.445-7.084-15.666-12.124-26.005-15.522-.332 12.156 2.63 23.481 6.564 33.692a135 135 0 0 0 5.12 11.57 77 77 0 0 1 3.292-3.675c5.746-5.535 10.843-10.139 15.441-10.954a15.6 15.6 0 0 1 3.728-.611m-22.46 15.24c-14.678-3.96-30.773-5.107-46.965-5.117 2.11 3.86 4.308 7.634 6.562 11.343 5.991 9.514 11.926 19.113 16.989 29.525 3.259-4.9 6.166-9.742 8.868-14.41 4.675-7.862 9.352-15.172 14.546-21.342m-23.414 35.75c-6.54-.142-13.034-.512-19.382-1.299-9.49-1.158-18.884-3.276-25.483-8.81l.027.057c3.16 5.652 3.41 12.69 3.21 19.78-.301 8.464-.339 16.924 1.613 24.627 2.107-1.41 4.894-2.792 8.184-4.414 3.37-1.547 7.505-3.813 12.104-7.177 5.857-4.66 10.245-9.52 13.521-14.002a176 176 0 0 0 6.206-8.761",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.23 705.128c27.14-299.699 457.425-250.687 458.168-253.34l-49.41 62.905s70.698 175.958 147.196 186.583c44.362 6.162-117.168-14.07-276.181-14.466-131.196-.327-264.51 18.828-279.773 18.318z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.99338639,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.86 575.398a25.183 16.606 0 0 1-9.096 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.705 25.183 16.606 0 0 1 34.458 5.794M246.946 537.544a25.183 16.606 0 0 1-9.094 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.889-22.705 25.183 16.606 0 0 1 34.458 5.794M275.35 578.31a25.183 16.606 0 0 1-9.096 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.458 5.793M238.425 615.854a25.183 16.606 0 0 1-9.094 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.889-22.704 25.183 16.606 0 0 1 34.458 5.793M168.7 615.261a25.183 16.606 0 0 1-9.096 22.67A25.183 16.606 0 0 1 125.2 632a25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.458 5.793M211.535 659.073a25.183 16.606 0 0 1-9.095 22.669 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.457 5.794M151.532 657.338a25.183 16.606 0 0 1-9.095 22.669 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.457 5.793M451.646 589.667a25.183 16.606 0 0 1-9.095 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.889-22.705 25.183 16.606 0 0 1 34.458 5.794M476.057 624.897a25.183 16.606 0 0 1-9.095 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.457 5.793M506.578 664.416a25.183 16.606 0 0 1-9.095 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.705 25.183 16.606 0 0 1 34.458 5.794M515.923 588.085a25.183 16.606 0 0 1-9.095 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.458 5.793M541.255 626.84a25.183 16.606 0 0 1-9.095 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.889-22.705 25.183 16.606 0 0 1 34.458 5.794M569.762 662.064a25.183 16.606 0 0 1-9.095 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.889-22.705 25.183 16.606 0 0 1 34.458 5.794M496.812 546.958a25.183 16.606 0 0 1-9.095 22.67 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.705 25.183 16.606 0 0 1 34.457 5.794M436.464 545.148a25.183 16.606 0 0 1-9.095 22.669 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.889-22.704 25.183 16.606 0 0 1 34.458 5.794M473.296 505.04a25.183 16.606 0 0 1-9.095 22.669 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.457 5.794M440.326 464.964a25.183 16.606 0 0 1-9.095 22.669 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.458 5.793M503.854 467.076a25.183 16.606 0 0 1-9.095 22.669 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.457 5.794",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.89 475.193c-23.29-1.45-52.55-5.036-66.38-8.134-23.801-5.332-39.51-13.128-49.652-24.644-7.68-8.72-10.403-16.145-10.427-28.43-.04-20.879 11.87-46.582 32.612-70.38 2.292-2.63 5.269-7.213 6.616-10.184s4.563-9.412 7.148-14.315l4.7-8.914-12.415-14.2c-13.198-15.094-18.154-21.62-24.332-32.04-2.116-3.569-5.078-8.313-6.583-10.543-3.34-4.95-2.434-9.49-2.413-14.064.043-9.307 7.596-20.256 24.587-33.588 7.625-5.982 8.917-9.254 31.466-10.291 9.629-.443 18.804-1.222 20.39-1.733 7.204-2.319 16.643-9.471 22.408-16.98 3.411-4.443 5.418-8.034 13.59-24.312 12.253-24.41 24.418-43.449 34.597-54.146 13.417-14.1 22.928-17.626 34.142-12.658 12.475 5.527 23.265 13.5 36.976 27.323l6.945 7.001 6.388-2.449c3.513-1.347 10.604-3.695 15.757-5.217 5.153-1.523 14.071-4.595 19.819-6.828 34.556-13.425 70.305-12.414 85.27 2.41 3.662 3.626 6.56 9.77 7.25 15.369.858 6.948-.865 35.396-2.823 46.631-3.094 17.751-3.52 15.42 3.9 21.368 3.533 2.832 10.47 9.036 15.417 13.787 4.948 4.751 11.002 10.258 13.455 12.238 6.158 4.97 12.413 12.722 15.043 18.646 4.594 10.346 4.77 19.59.633 33.501-1.36 4.577-3.367 12.518-4.459 17.648s-3.34 13.911-4.996 19.515l-3.012 10.19 5.347 6.435c2.94 3.54 7.273 9.047 9.629 12.237s6.49 7.648 9.187 9.906c18.858 15.78 30.14 37.737 27.684 53.876-1.197 7.86-4.002 13.584-10.365 21.148-13.29 15.8-37.772 29.796-70.588 40.355-7.29 2.345-8.348 2.462-28.828 3.167-30.651 1.055-38.505 1.607-96.932 6.814-17.44 1.555-37.224 3.209-43.962 3.676-17.268 1.197-59.087 1.662-72.79.809",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.276 375.371c-19.343 2.588-54.339-16.752-57.163-15.57-1.35.564 43.655 21.607 39.923 22.51-17.524 4.238-36.728 5.019-54.682 7.062l67 4-68 16c23.166-.688 51.346-7.42 69.75-2.75-2.596-9.502.193-22.679 3.172-31.252z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.94639778,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.658 440.694-106.31-38.31 48.758 37.237-57.768-9.476 84.384 53.223z",
    style: {
      fill: "#b93c3c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-147.746 567.81a24.92 24.92 0 0 1-15.227 23.359 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.386 24.92 24.92 0 0 1 23.431-15.115",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-51.76 -228.035 -148.007)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.342 652.413a24.92 24.92 0 0 1-15.228 23.358 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.386 24.92 24.92 0 0 1 23.432-15.114",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-37.932 -327.943 -160.462)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-94.167 671.856a24.92 24.92 0 0 1-15.227 23.358 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.386 24.92 24.92 0 0 1 23.431-15.114",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-44.364 -274.114 -153.751)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-371.41 493.371a24.92 24.92 0 0 1-15.228 23.359 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.386 24.92 24.92 0 0 1 23.432-15.115",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-65.998 -166.645 -140.353)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.162 720.083a24.92 24.92 0 0 1-15.228 23.359 24.92 24.92 0 0 1-27.359-5.381 24.92 24.92 0 0 1-5.248-27.385 24.92 24.92 0 0 1 23.431-15.115",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-27.375 -468.797 -178.021)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-418.742 566.537a24.92 24.92 0 0 1-15.227 23.358 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.386 24.92 24.92 0 0 1 23.431-15.115",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-65.998 -166.645 -140.353)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.879 760.11a24.92 24.92 0 0 1-15.228 23.358 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.386 24.92 24.92 0 0 1 23.431-15.114",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-27.375 -468.797 -178.021)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-198.851 778.226a24.92 24.92 0 0 1-15.228 23.358 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.385 24.92 24.92 0 0 1 23.432-15.115",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-44.364 -274.114 -153.751)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.656 692.799a24.92 24.92 0 0 1-15.228 23.358 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.386 24.92 24.92 0 0 1 23.432-15.114M402.951 763.652a24.92 24.92 0 0 1-15.227 23.358 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.385 24.92 24.92 0 0 1 23.431-15.115",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-7.008 -1908.285 -357.475)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-612.644 243.543a24.92 24.92 0 0 1-15.227 23.358 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.385 24.92 24.92 0 0 1 23.431-15.115M-688.504 294.545a24.92 24.92 0 0 1-15.228 23.359 24.92 24.92 0 0 1-27.36-5.38 24.92 24.92 0 0 1-5.248-27.386 24.92 24.92 0 0 1 23.432-15.115",
    style: {
      opacity: 1,
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 20.33586311,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    transform: "rotate(-90.036 -102.995 -132.418)scale(.8878)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.107 504.085a25.183 16.606 0 0 1-9.095 22.669 25.183 16.606 0 0 1-34.405-5.93 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.457 5.793M333.05 543.47a25.183 16.606 0 0 1-9.095 22.668 25.183 16.606 0 0 1-34.405-5.929 25.183 16.606 0 0 1 8.89-22.704 25.183 16.606 0 0 1 34.458 5.793",
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.605 688.242c-52.736 2.37-102.162 3.154-153.696-9.292-30.147-2.815-89.072 17.624-151.22 18.24-40.777 3.19-40.912-13.405-26.318-36.91 21.632-34.366 113.75-82.146 184.873-122.462-25.895-.717-84.215-18.113-90.96-45.957-4.827-18.877.793-41.421 21.89-47.383 22.095-6.311 27.19-8.094 60.14 1.757 11.042.369 22.928 13.182 32.78 19.422 13.946 15.993 30.809 28.392 34.484 57.044-.526 12.677-1.428 25.353-9.075 38.03-16.13 16.348-53.27 41.058-74.231 49.961 19.954-6.363 57.302-27.193 76.046-36.539 28.672 43.743 61.87 79.118 95.287 114.089",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 12.43374538,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.16 463.809c-2.064 3.773-3.194 5.76-2.6 11.986 3.66 4.296 6.332 8.5 14.35 3.17 5.136-4.427 3.875-7.418 3.553-11.451-2.718-6.087-2.35-8.144-6.012-9.095-4.443-.76-6.935 3.578-9.291 5.39",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.12 432.738c-49.278-3.168-76.03-15.687-124.124-22.4 36.497 1.182 53.092 4.613 90.227 1.967-39.703-13.14-37.722-16.572-74.721-31.74 47.699 15.815 57.73 13.044 115.25 20.87z",
    style: {
      fill: "#004900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.437 161.052c-8.893-6.986-9.596-15.38-1.275-25.322l-17.724 15.694 11.443-25.79-17.252 20.043 4.433-25.814-10.043 22.071-5.62-22.21-3.118 25.648-9.292-24.273c5.172 22.576-1.071 29.418-7.162 43.784 19.508-8.962 36.681-13.802 55.61-3.83",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 3.95740938,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.482 173.903c-2.157-7.055-7.246-12.855-15.318-17.376l12.772-21.934-20.517 16.326 6.078-25.838-14.182 23.833-3.364-25.438-7.17 24.095-11.267-20.407c-.998 9.31 1.388 20.213-15.852 21.864 20.59 2.747 57.323 15.555 68.82 24.875",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.41672087,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.702 228.511c6.875-13.441 5.915-21.66 8.37-32.155l4.746 29.194 17.277-18.622-6.439 23.716 25.678-12.477-15.46 17.05 30.251 1.62-23.557 5.59 22.563 12.953c-11.796-5.729-23.72-6.61-36.56 7.488 2.46-28.947-12.41-30.988-26.869-34.357z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.35753345,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.5 268.862-55.5 19c11.796 6.045 19.025 9.129 21.5 20.5l34-10-35 2 30-14-33 4zM527.05 357.02c12.103 4.572 17.166 8.931 38.63 8.824l-50.63 7.175zM489.615 400.171c20.376.335 42.007-6.007 62.284-9.171-17.76 9.749-37.231 10.936-55.931 15.983 15.095 4.816 29.735 9.954 47.827 15.239-18.986-1.7-37.03-6.473-51.695 1.018 11.113 5.64 21.613 11.383 41.449 15.569l-72.096-2.878c14.263-2.365 31.606-26.677 28.162-35.76z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.94639778,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.16 267.467c.459-18.043.929-20.107 10.674-28.752-19.915-3.333-23.144-12.726-34.542-20.814L244 243.328l-45.77-13.985 36.87 19.071h-49.584l41.956 6.357c-2.18 9.57-17.052 9.672-32.42 16.528 16.212-3.928 40.283-10.067 53.108-3.832z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.44686604,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.59 177.542c3.705 16.003 4.913 30.006 16.657 43.048-7.194-3.158-8.715 1.56-21.556 3.342 6.278-15.877 1.224-31.052 4.9-46.39z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.26737165,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.246 293.615c-29.54-11.713-33.184-7.38-33.184-7.38l30.458 13.04z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 4.42769051,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.223 628.416c-20.065 4.58-36.05 17.486-47.198 26.263 12.14-3.878 26.67-8.53 39.508-9.756 6.82-.173 6.597-.216 5.801 3.713l15.658-38.792c-3.42 3.582-8.362 16.104-13.769 18.572z",
    style: {
      fill: "#000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: ".45772466px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSou1);
export default __webpack_public_path__ + "static/media/Sou1.99d530cfb51deb6cd0a20707b6314ede.svg";
export { ForwardRef as ReactComponent };